import styled, { css } from 'styled-components';
import Drawer from 'antd/es/drawer';

export const Container = styled.div`
  min-width: 150px;
  width: 100%;
  height: 100%;
`;
export const StyledDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-body {
      padding: 0px 0px;
      overflow: scroll;
    }

    .setur-drawer-header {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .setur-drawer-content-wrapper {
      height: 100% !important;
    }

    .setur-drawer-title {
      font-family: Source Sans Pro;
      font-weight: 600;
    }

    .setur-drawer-close {
      font-weight: bold;
      font-size: 24px;
      padding: 0px;
      margin-right: 11px;
      top: unset;
      color: ${({ theme }) => theme.palette.black};
    }

    @keyframes shake {
      10%,
      90% {
        transform: translate3d(-1px, 0, 0);
      }

      20%,
      80% {
        transform: translate3d(2px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-4px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(4px, 0, 0);
      }
    }
  }
`;

export const ResponsiveSearchDrawerItemContent = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgba(75, 75, 75, 0.2);
  padding: 15px 10px !important;
  height: fit-content;

  &.border-bottom-hidden {
    border-bottom: none;
  }
`;

export const ResponsiveSearchDrawerItemText = styled.div`
  flex: 1;
`;

export const ResponsiveSearchDrawerItemTitle = styled.span`
  font-size: 12px;
  font-weight: bold;
  font-family: Source Sans Pro;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const ResponsiveSearchDrawerItemSubtitle = styled.span<{
  isEmpty: boolean;
}>`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.matterHorn};
  ${({ isEmpty }) =>
    isEmpty &&
    css`
      opacity: 0.5;
    `}
`;

export const ErrorMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
`;

export const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #f79c7f;
`;

export const ErrorMessage = styled.div`
  white-space: nowrap;
  background-color: #f79c7f;
  font-size: 10px;
  color: #602410;
  font-weight: 400;
  padding: 3px 6px;
`;
